import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import PackageShop from './../pages/PackageShop';
import PackageBenefit from './../pages/PackageBenefit';
import PackageHistory from './../pages/PackageHistory';
import TicketPage from './../pages/TicketPage';
import NotFoundPage from './../pages/NotFoundPage';
import ReservationPage from './../pages/ReservationPage';
import ReservationProcessPage from "../pages/ReservationProcessPage";
import ReservationResultPage from "../pages/ReservationResultPage";

class AppRouter extends Component {
    render() {
        return (
            <Switch>
                <Route 
                    exact
                    path="/package/:barcode/history" 
                    component={PackageHistory} 
                />
                <Route 
                    exact
                    path="/package/:barcode/benefit" 
                    component={PackageBenefit} 
                />
                <Route
                    path="/package/:barcode" 
                    component={PackageShop} 
                />
                <Route
                    path="/tickets/:barcode/reserve"
                    component={ReservationPage}
                />
                <Route 
                    path="/tickets/:barcode"
                    component={TicketPage} 
                />
                <Route
                  path="/result/:barcode/reserve/:pin"
                  component={ReservationResultPage}
                />
                <Route
                    path="/reserve/:barcode/pin/:pin"
                    component={ReservationProcessPage}
                />
                <Route exact path="/" component={NotFoundPage} />
                <Route component={NotFoundPage} />
            </Switch>
        )
    }
}

export default AppRouter;


// WEBPACK FOOTER //
// ./src/router/index.js